import React, { useEffect, useMemo } from "react"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from "~/ui/styled"
import { Flex, ColumnFlex, StartFlex, CenterFlex, Text, IconFont } from "~components/El"
import Select from "../components/Select"
import { NotDisturbModeScreenProps } from "./types"
import { useStores } from "~models"
import { DND_TIME_SLOT_OPTIONS, getDndTimeSlotLabel } from "../dnd-time-slot-options"

const Container = styled.View`
  flex-direction: column;
  flex: 1;
  padding: 0 12px;
`
const Dotted = styled(CenterFlex)`
  width: 4px;
  height: 4px;
  margin-right: 10px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.primaryText};
`

const tips = [
  "免打扰期间不会收到消息通知",
  "免打扰不影响消息的正常接收",
  "可以在设置中随时关闭此功能",
]

const NotDisturbMode: React.FC<NotDisturbModeScreenProps> = ({ route }) => {
  void route
  const theme = useTheme()
  const { settingStore, walletStore } = useStores()

  useEffect(() => {
    walletStore.getWalletInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- MobX root store stable
  }, [])

  const currentSlot =
    walletStore.dnd_time_slot != null &&
    walletStore.dnd_time_slot >= 1 &&
    walletStore.dnd_time_slot <= 6
      ? walletStore.dnd_time_slot
      : 1
  const selectedSlot = String(currentSlot)

  const previewText = useMemo(() => {
    const range = getDndTimeSlotLabel(currentSlot)
    if (walletStore.dnd_enabled !== true) {
      return `免打扰已关闭 · 已选：${range}`
    }
    return `免打扰已开启 · ${range}`
  }, [walletStore.dnd_enabled, currentSlot])

  return (
    <Container>
      <ColumnFlex
        width="100%"
        mt="10px"
        padding="0 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <Select
          title=""
          description="选择免打扰的时间段"
          options={DND_TIME_SLOT_OPTIONS}
          value={selectedSlot}
          onChange={(val) => {
            const n = Number(val)
            if (n >= 1 && n <= 6) settingStore.setDoNotDisturbTimeSlot(n)
          }}
        />
      </ColumnFlex>
      <Flex
        flexDirection="column"
        width="100%"
        mt="10px"
        padding="10px 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <Text color={theme.colors.secondaryText} fontSize={theme.fontSizes.sm} lineHeight="20px">
          {previewText}
        </Text>
      </Flex>
      <Flex flexDirection="column" width="100%" mt="10px" padding="10px 12px" borderRadius="8px" bg="rgba(78, 152, 243, 0.1)">
        <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.md} fontWeight="600">
          <IconFont name="jilu" size={12} color={theme.colors.purpleBackground} />
          &nbsp;&nbsp;免打扰说明
        </Text>
        <Flex flexDirection="column" width="100%" mt="10px" pl="26px">
          {tips.map((text, index) => (
            <StartFlex key={index}>
              <Dotted />
              <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.sm} lineHeight="18px">
                {text}
              </Text>
            </StartFlex>
          ))}
        </Flex>
      </Flex>
    </Container>
  )
}

export default observer(NotDisturbMode)
